import { CommonLaboratoryDatasource } from '@/shared/resources/datasources/common/common-laboratory-datasource'
import DiagnosisCaseService from '@/modules/diagnosisModule/services/DiagnosisCaseService'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { Nullable } from '@/shared/types/app.types'
import { cloneDeep, isEmpty } from 'lodash'

export class BatchActionsDatasource<T> extends CommonLaboratoryDatasource<T> {
    private readonly _searchCaseActive: boolean
    private readonly _params: Nullable<Record<string, any>>
    private readonly _externalFilterModel: CommonFilterModel

    constructor(
        laboratoryId: number,
        searchCaseActive: boolean,
        params: Record<string, any>,
        externalFilterModel: CommonFilterModel
    ) {
        super(laboratoryId)

        this._searchCaseActive = searchCaseActive
        this._params = params
        this._externalFilterModel = externalFilterModel
    }

    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<T>> {
        const _params = {
            ...this._params,
            ...params
        }

        let filter = cloneDeep(filterModel)
        if (!isEmpty(this._externalFilterModel)) {
            const combine =
                Object.keys(this._externalFilterModel).some(
                    colId => Object.keys(filterModel).includes(colId))
            if (combine) {
                Object.keys(this._externalFilterModel).forEach(colId => {
                    if (filterModel[colId]) {
                        filter[colId] = {
                            condition1: this._externalFilterModel[colId],
                            condition2: filterModel[colId],
                            filterType: this._externalFilterModel[colId].filterType,
                            operator: 'AND'
                        }
                    } else {
                        filter[colId] = this._externalFilterModel[colId]
                    }
                })
            } else {
                filter = Object.assign(filter, this._externalFilterModel)
            }
        }

        return this._searchCaseActive
            ? DiagnosisCaseService.getCasesForBatchActions(this.laboratoryId, _params, filter)
            : DiagnosisCaseService.getSamplesForBatchActions(this.laboratoryId, _params, filter)
    }
}
